import { CUISINE_TYPE, PUBLIC, SEARCH_STRING } from "./constants";

export const fetchIdFromUrl = (url) => {
    let regex = /v2\/(.*?)\?/;
    let match = url.match(regex);

    if (match) {
        let id = match[1];
        return id;
    } else {
        console.error(match);
    }

}

export const getApiParams = () => {
    return {
        type: PUBLIC,
        app_id: process.env.REACT_APP_API_ID,
        app_key: process.env.REACT_APP_API_KEY
    }
}

export const getRecipeParamsForSweets = () => {
    return {...getApiParams(),
        field: ["url","label","image","images"],
        imageSize:["LARGE","SMALL","REGULAR"],
        dishType: ["Desserts", "Biscuits and cookies", "Pancake", "Sweets"],
        random: true   
    }
}

export const getRecipeParamsForSuperDelicious = () => {
    return {...getApiParams(),
        field: ["url","label","image","images"],
        imageSize:["LARGE","SMALL","REGULAR"],
        time: "5-10",
        random: true   
    }
}

export const getRecipeParamsForAll = (cuisineType, searchString) => {
    const obj = {...getApiParams(),
        field: ["url","label","image","images"],
        imageSize:["LARGE","SMALL","REGULAR"],
    }
    if(cuisineType!==undefined){
        obj[CUISINE_TYPE]= cuisineType
    } else if(searchString !== undefined){
        obj[SEARCH_STRING] = searchString
    }
    return obj;
}

export const getImageUrl = (images) =>{
    const imageSize = images.LARGE ?? images.REGULAR ?? images.SMALL;
    return imageSize?.url;
}
